import { getDocumentOrThrow } from "@faire/web--source/common/globals/getDocument";
export var downloadBinaryAsFile = function(data, fileName) {
    var link = getDocumentOrThrow().createElement("a");
    if ((link === null || link === void 0 ? void 0 : link.download) !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(data);
        link.setAttribute("href", url);
        link.setAttribute("download", fileName);
        link.style.visibility = "hidden";
        getDocumentOrThrow().body.appendChild(link);
        link.click();
        getDocumentOrThrow().body.removeChild(link);
    }
};
